/**
 * Eine Wortgrenze, die ä ö ü ß kennt. (21.09.2026)
 *
 * ## Der Befund
 *
 * `\b` in JavaScript kennt nur ASCII-Wortzeichen. Ein Umlaut ist für `\b`
 * KEIN Wortzeichen — also liegt zwischen einem Leerzeichen und einem „ö"
 * gar keine Grenze, und `\böffnen\b` trifft „den Player öffnen" NIE.
 *
 *     /\böffnen\b/i.test("den Player öffnen")   → false
 *     /\bsuchen\b/i.test("das bitte suchen")    → true
 *
 * Gemessen am 21.09.2026 lagen dadurch in sieben Regeln des Hauses tote
 * Alternativen:
 *
 *   server/absicht.ts          öffnen, übersetzen, ändern (TU_WORT)
 *   server/werkzeug-auswahl.ts öbb
 *   server/claude-sdk-session.ts übersetz*
 *   server/instant-ticket.ts   öbb
 *   memory/fact-gate.ts        über (die ganze Regel war tot)
 *   tools/oebb-sichtbar.ts     öbb
 *   tools/chat_history_search.ts über
 *
 * Alle still: die Regel lief, sie traf nur nie. Wer „ÖBB" schrieb, bekam
 * die Reiseauskunft nicht; wer „den Player öffnen" sagte, bekam keinen
 * Auftrags-Hinweis.
 *
 * ## Die Lösung
 *
 * Ein Blick zurück und einer nach vorn auf „kein Buchstabe, keine Ziffer,
 * kein Unterstrich" — mit `u`-Kennzeichen, damit `\p{L}` gilt. Das ist
 * dieselbe Absicht wie `\b`, nur in einer Sprache mit Umlauten.
 */

/** Ein Wortzeichen — Buchstabe (auch ä ö ü ß), Ziffer, Unterstrich. */
export const WORT_ZEICHEN = "[\\p{L}\\p{N}_]";

/** Kein Wortzeichen davor. */
export const WORT_VOR = `(?<!${WORT_ZEICHEN})`;

/** Kein Wortzeichen danach. */
export const WORT_NACH = `(?!${WORT_ZEICHEN})`;

/**
 * Ein Muster zwischen zwei Wortgrenzen — der Ersatz für `/\b(a|b|c)\b/`.
 *
 * ⚠️ `flags` OHNE `u` uebergeben; das wird hier gesetzt. Und wer im Muster
 *    `\w` braucht, nimmt `WORT_ZEICHEN` — `\w` ist genauso ASCII-eng wie
 *    `\b` und wuerde denselben Fehler an der naechsten Stelle machen.
 */
export function wortGrenze(muster: string, flags = "i"): RegExp {
  return new RegExp(`${WORT_VOR}(?:${muster})${WORT_NACH}`, `${flags}u`);
}

/**
 * Nur die vordere Grenze — für Muster, die selbst weiterlaufen
 * („kauf" plus beliebige Endung).
 */
export function wortAnfang(muster: string, flags = "i"): RegExp {
  return new RegExp(`${WORT_VOR}(?:${muster})`, `${flags}u`);
}
